import {useTranslation} from 'react-i18next'
import type {Investigacion} from '@/hooks/sgsst/incidentes/use-investigacion'
import {cn} from '@/lib/utils'

export const PASOS = ['equipo', 'cronologia', 'causas', 'medidas', 'informe'] as const
export type Paso = (typeof PASOS)[number]

/** No bloquea: los pasos del 1401 se abren en cualquier orden; solo marca dónde quedó trabajo. */
function pasoLleno(inv: Investigacion, paso: Paso): boolean {
  if (paso === 'equipo') return inv.equipo.length > 0
  if (paso === 'cronologia') return !!inv.cronologia
  if (paso === 'causas') return inv.causas.length > 0
  if (paso === 'medidas') return inv.medidas.length > 0
  return inv.estado === 'completa'
}

export function PasosNav({inv, paso, onPaso}: {inv: Investigacion; paso: Paso; onPaso: (p: Paso) => void}) {
  const {t} = useTranslation()
  return (
    <nav
      className="surface flex flex-wrap gap-1 p-1"
      data-testid="investigacion-pasos"
      aria-label={t('investigacion.pasosAria')}>
      {PASOS.map((p, i) => {
        const activo = paso === p
        const lleno = pasoLleno(inv, p)
        return (
          <button
            key={p}
            type="button"
            data-testid={`paso-tab-${p}`}
            data-lleno={lleno}
            aria-current={activo ? 'step' : undefined}
            onClick={() => onPaso(p)}
            className={cn(
              'inline-flex min-h-11 min-w-24 flex-1 items-center justify-center gap-1.5 rounded-md px-2.5 text-xs font-medium transition-colors sm:min-h-9',
              activo
                ? 'bg-primary text-primary-foreground shadow-button'
                : 'text-muted-foreground hover:bg-secondary hover:text-foreground'
            )}>
            <span className={cn('font-mono tabular-nums', activo ? 'opacity-70' : 'opacity-60')}>{i + 1}</span>
            <span className="min-w-0 truncate">{t(`investigacion.paso.${p}`)}</span>
            <span
              aria-hidden="true"
              className={cn(
                'size-1.5 shrink-0 rounded-full',
                lleno ? (activo ? 'bg-primary-foreground' : 'bg-primary') : 'bg-transparent'
              )}
            />
          </button>
        )
      })}
    </nav>
  )
}
